import React from 'react';
import styles from './button.scss';
import { Link } from 'react-router-dom';

interface ButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  type?: string;
  square?: boolean;
  big?: boolean;
  circle?: boolean;
  success?: boolean;
  warning?: boolean;
  tab?: boolean;
  primary?: boolean;
  icon?: React.CElement;
  iconRight?: React.CElement;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  raised?: string | boolean;
  flat?: string;
  link?: String | (() => String);
  /** Enable to make buttons with only an icon look the same as buttons with text */
  preventIcon?: boolean;
  smallCaps?: boolean;
  tabIndex?: number;
}

function Button({
  big,
  circle,
  square,
  type,
  success,
  primary,
  warning,
  flat,
  raised,
  icon,
  iconRight,
  disabled,
  className,
  link,
  tab,
  preventIcon,
  smallCaps,
  tabIndex = 0,
  ...rest
}: ButtonProps) {
  const cl = [styles.root];
  if (className) cl.push(className);
  if (square) cl.push(styles.square);

  if (big) cl.push(styles.big);
  if (raised) cl.push(styles.raised);
  else if (circle) cl.push(styles.circle);
  else if (!flat && !preventIcon) cl.push(styles.icon);

  if (tab) cl.push(styles.tab);
  if (primary) cl.push(styles.primary);
  else if (warning) cl.push(styles.warning);
  else if (success) cl.push(styles.success);

  if (smallCaps) cl.push(styles.smallCaps);
  if (disabled) {
    cl.push(styles.disabled);
    rest.disabled = true;
  }

  let label = false;
  if (raised && typeof raised !== 'boolean') label = raised;
  if (flat) label = flat;

  if (link) {
    return (
      <Link
        to={link}
        type={type || 'button'}
        className={cl.join(' ')}
        tabIndex={tabIndex}
        {...rest}
      >
        {icon || circle}
        {label && <span className={styles.label}>{label}</span>}
        {iconRight}
      </Link>
    );
  }
  return (
    <button type={type || 'button'} className={cl.join(' ')} tabIndex={tabIndex} {...rest}>
      {icon || circle}
      {label && <span className={styles.label}>{label}</span>}
      {iconRight}
    </button>
  );
}

export default Button;
